import React, { Component } from "react";
import _ from "lodash";
import track from "../lib/tracking"
import HubspotForm from 'react-hubspot-form'
 


type Props = {
  display: false,
};
type State = {
};


class ContactPopup extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div className={`contact-popup${this.props.display ? "" : "--hidden" }`}>
        <div className="contact-popup__content">
          <div className="contact-popup__title">To see the results of your Audience Calculator search please enter your email address below.</div>
          <HubspotForm
            portalId="3477242"
            formId="b3dd80b8-09e1-4322-83c6-211513205722"
            onSubmit={this.props.onFormSubmited}
            onReady={(form) => console.log('Form ready!')}
            loading={<div>Loading...</div>}
          />
        </div>
      </div>
    );
  }
}

export default ContactPopup;



// WEBPACK FOOTER //
// ./src/components/ContactPopup.js